var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.624 1.66666V6.09342C10.624 6.52311 10.9756 6.87467 11.4053 6.87467H15.832V17.5524C15.8319 17.9852 15.4836 18.3337 15.0508 18.3337H4.11328C3.68045 18.3337 3.33221 17.9852 3.33203 17.5524V2.44791C3.33203 2.01497 3.68034 1.66666 4.11328 1.66666H10.624ZM5.83203 13.1247C5.6237 13.1247 5.41504 13.3333 5.41504 13.5417V15.8337C5.41526 16.0419 5.62381 16.2497 5.83203 16.2497H7.08203C7.29026 16.2497 7.49881 16.0419 7.49902 15.8337V13.5417C7.49902 13.3333 7.29036 13.1247 7.08203 13.1247H5.83203ZM8.95703 8.95866C8.74881 8.95866 8.54026 9.16645 8.54004 9.37467V15.8337C8.54026 16.0419 8.74881 16.2497 8.95703 16.2497H10.207C10.4153 16.2497 10.6238 16.0419 10.624 15.8337V9.37467C10.6238 9.16645 10.4153 8.95866 10.207 8.95866H8.95703ZM12.082 11.0417C11.8737 11.0417 11.665 11.2503 11.665 11.4587V15.8337C11.6653 16.0419 11.8738 16.2497 12.082 16.2497H13.332C13.5403 16.2497 13.7488 16.0419 13.749 15.8337V11.4587C13.749 11.2503 13.5404 11.0417 13.332 11.0417H12.082ZM11.8643 1.66666C12.0723 1.66675 12.2706 1.748 12.417 1.8942L15.6045 5.08463C15.7508 5.23102 15.8319 5.42955 15.832 5.63444V5.83366H11.665V1.66666H11.8643Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentChart);
export default __webpack_public_path__ + "static/media/document-chart.7747b44a315dbaeb845a397dd4528595.svg";
export { ForwardRef as ReactComponent };